const config = {
  apiBaseUrl: "https://theurbanneed.in/admin/API/",
  baseUrl: "https://theurbanneed.in/admin/",
};

export default config;
